export default {"src":"/_next/static/media/roundStarIcon.0e5e73fd.svg","height":140,"width":142,"blurWidth":0,"blurHeight":0};